export const uniq = (arr: string[]) => {
  const map = new Map();
  return arr.filter((item) => {
    return !map.has(item) && map.set(item, 1);
  });
}

export function getQueryParam(url: string, paramName: string) {
  try {
    // 创建一个正则表达式来匹配 query 参数
    const regex = new RegExp(
      '[?&]' + encodeURIComponent(paramName) + '=([^&]*)'
    );
    const match = regex.exec(url);

    // 如果找到匹配项，返回参数值
    return match ? decodeURIComponent(match[1]) : null;
  } catch (err: any) {
    console.error('[getQueryParam]', err);
    return null;
  }
}
